var _defs, _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconFeedbackDone = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0;}.b{fill-rule:evenodd;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 24,
  height: 24
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M-2689-213.867a1.02,1.02,0,0,1-.7-.28.987.987,0,0,1-.306-.722V-229a4.005,4.005,0,0,1,4-4h12a4,4,0,0,1,4,4v8a4,4,0,0,1-4,4h-10l-4.445,2.964A.993.993,0,0,1-2689-213.867Zm7.032-14.708a2.4,2.4,0,0,0-1.707.707,2.4,2.4,0,0,0-.707,1.707,2.4,2.4,0,0,0,.707,1.707l3,3a1.007,1.007,0,0,0,.708.293,1.006,1.006,0,0,0,.707-.293l3-3a2.4,2.4,0,0,0,.707-1.707,2.4,2.4,0,0,0-.707-1.707,2.4,2.4,0,0,0-1.707-.707,2.4,2.4,0,0,0-1.707.707l-.292.292-.293-.292A2.4,2.4,0,0,0-2681.965-228.575Z",
  transform: "translate(2692 235)"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconFeedbackDone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-feedback-done.de1b1ab5.svg";
export { ForwardRef as ReactComponent };